import React, { FC, useEffect } from 'react';
import { Reports } from '../../components/reports/Reports';
import { PaymentsReports } from '../../components/reports/PaymentsReports';
import { Spinner } from '../../components/Spinner';
import { fetchReportTypesList } from '../../store/order/actions/reports';
import { useOrdersContext } from '../../store/order/order-context';
import { fetchPaymentReportTypesList } from '../../store/payments/actions/reports';
import { usePaymentContext } from '../../store/payments/payments-context';

export const ReportsPage: FC = () => {
	const { paymentContextState: { isPaymentReportTypesListLoading }, dispatch: paymentDispatch } = usePaymentContext();
	const { orderContextState: { isReportListLoading }, dispatch: orderDispatch } = useOrdersContext();

	useEffect(() => {
		void fetchPaymentReportTypesList(paymentDispatch);
	}, []);

	useEffect(() => {
		void fetchReportTypesList(orderDispatch);
	}, []);

	if (isPaymentReportTypesListLoading || isReportListLoading) {
		return (
			<div className="card">
				<div className="card-body loading-full-height">
					<Spinner pageLoader/>
				</div>
			</div>
		);
	}
	return (
		<>
			<Reports/>
			<PaymentsReports/>
		</>
	);
};
